import { Component, EventEmitter, Output, effect, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { IBucketItem, ITags } from "../models/bucket-item.model";
import { BreadcrumbDataService } from "../../../main/layout/tool-bar/breadcrumb-service/breadcrumb-data.service";
import { IBreadcrumbItem } from "../../../main/layout/tool-bar/model/breadcrumb.model";
import { DataService } from "../service/data.service";
import { IUpdateTag, IUpdateTagResponse, TagsRequest } from "../models/update-tag.model";
import { BucketItemService } from "../service/bucket-item.service";
import { MessageService } from "../../../main";
import { AppSettingsService, SpinnerService } from "../../../core";
import { catchError, map, throwError } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import { RowDataService } from "../service/row-data.service";
import { JustificationDialogComponent } from "../../../shared/justification-dialog/justification-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { CommonConsants } from "../constants/component-constants";
import { MatDivider } from "@angular/material/divider";
import { DynamicControlsComponent } from "../../../dynamic-controls/dynamic-controls.component";

@Component({
    selector: "app-multiple-tags",
    templateUrl: "./multiple-tags.component.html",
    styleUrls: ["./multiple-tags.component.scss"],
    imports: [MatDivider, DynamicControlsComponent]
})
export class MultipleTagsComponent {
  private bucketItemsService = inject(BucketItemService);
  private rowDataService = inject(RowDataService);
  private messageService = inject(MessageService);
  private appSettingService = inject(AppSettingsService);
  private spinnerService = inject(SpinnerService);
  private dialog = inject(MatDialog);

  @Output() cancelMultitagsOperation: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  public title = "Add Tag to Multiple Files";
  public count = 0;
  public currentBreadcrumbItem: Partial<IBreadcrumbItem> = {};
  private breadcrumbDataService = inject(BreadcrumbDataService);
  private dataService = inject(DataService);
  public clickedBucketItem: Partial<IBucketItem> = null;
  public selectedBucketItems: Partial<IBucketItem>[] = [];
  private readonly _breadcrumb = toSignal(this.breadcrumbDataService.getCurrentBreadCrumbItem());
  private readonly _allSelected = toSignal(this.dataService.getAllSelectedData());
  private readonly _clickedRow = toSignal(this.rowDataService.getClickedRowData());
  @Output() tagsUpdated = new EventEmitter<boolean>();
  @Output() unSelectFoldersForMultipleTags = new EventEmitter<boolean>();
  public updateTagsRequest : Partial<IUpdateTag> = {};

  constructor() {
    effect(() => {
      const item = this._breadcrumb();
      if (item != null) this.currentBreadcrumbItem = item;
    });
    effect(() => {
      const data = this._allSelected() ?? [];
      this.selectedBucketItems = data;
      this.count = data.filter((x) => x.Type === "File").length;
    });
    effect(() => {
      const data = this._clickedRow();
      if (data) this.clickedBucketItem = data;
    });
  }

  public selectedTags(selectedTags: Partial<ITags>[]) {
    var tags: TagsRequest[] = [];
    if(this.selectedBucketItems.some(x => x.FolderType === "SubFolder")){
      this.messageService
      .confirm(
        "Tags cannot apply to folders. The selected folders will be automatically unselected.",
        "Invalid selection",
        "Confirm",
        "Cancel"
      )
      .subscribe((result: string|boolean) => {
        if (result===true) {          
          this.unSelectFoldersForMultipleTags.emit(true);
          this.UpdateSelectedTags(tags,selectedTags); 
        }
      });
    }
    else{
      this.UpdateSelectedTags(tags,selectedTags); 
    }
  }

  public UpdateSelectedTags(tags: TagsRequest[],selectedTags: Partial<ITags>[]){
    this.selectedBucketItems.forEach((element) => {
      if (element.Type === "File"){
        const tagItem: TagsRequest = {
          BucketItemId: element.Id,
          tags: [...selectedTags],
        };
      tags.push(tagItem);
      }
    });
    this.updateTagsRequest = {...this.updateTagsRequest,
      BucketType: this.currentBreadcrumbItem.BucketType,
      BUCode: this.currentBreadcrumbItem.BUCode,
      PackageId: this.clickedBucketItem.PackageId,
      Tags: [...tags],
    };
    this.bucketItemsService
      .UpdateTags(this.updateTagsRequest )
      .pipe(
        map((res: IUpdateTagResponse) => {
          this.spinnerService.show(false);
          if(res.JustificationRequired){
            this.dialog.open(JustificationDialogComponent,{
              width:"450px",
              disableClose:true
            }).afterClosed().subscribe(
              (response: {comment:string})=>{
                if(response && response.comment){
                  this.updateTagsRequest.Comment = response.comment;
                  //It will make the process continue after giving the justification
                  this.selectedTags(selectedTags);
                }
              }
            );
          }else{
            this.tagsUpdated.emit(true);
            if(res.SuccessfulMessage == CommonConsants.UPDATE_TAGS_PARTIAL_PERMISSION){
              this.messageService.warning(res.SuccessfulMessage,this.appSettingService.toastrDisplayTime);
            }
            else{
              this.messageService.success(res.SuccessfulMessage,this.appSettingService.toastrDisplayTime);
            }
          }
        }),
        catchError((error: HttpErrorResponse) => {
          this.spinnerService.show(false);
          if(error.error.detail !== undefined){
            this.messageService.alert(error.error.detail,this.appSettingService.toastrDisplayTime);
          }
          else{
            this.messageService.alert("Not able to update Tag(s).Please try again later.",this.appSettingService.toastrDisplayTime);
          }
          return throwError(() => new Error(error.message));
        })
      )
      .subscribe();
  }

  public cancel(value: boolean) {
    this.cancelMultitagsOperation.emit(value);
  }
}
